import { render, staticRenderFns } from "./ComplaintsStats.vue?vue&type=template&id=396b20ec"
import script from "./ComplaintsStats.vue?vue&type=script&lang=js"
export * from "./ComplaintsStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports